<!--
Works only in vue3
vue2 file: Velocity.PrimaryOffersites.Web\wwwroot\js\components\FooterPopups\googleassistant.vue
-->
<template>
  <div>
    <Modal @hideModal="closeModal()">
      <div class="px-2 py-2">
        <div
          class="whiteplains-honda grey-color-text"
          v-if="vehicleAccounts.WHITEPLAINSHONDA === currentAccountId"
        >
          <div class="blue-text font-weight-bold">WHITE PLAINS HONDA - GOOGLE ASSISTANT</div>
          <div class="blue-text font-weight-bold mt-2">TERMS OF USE</div>
          <div class="red-text mt-2"><em>Updated: June 26, 2019</em></div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">ACCEPTANCE OF TERMS</div>
            <div class="mt-1">
              These <span class="font-weight-bold">Google Assistant Terms of Use</span> (or Terms)
              govern your use of our Google Assistant Action (Application). Before using the
              Application, you should review any terms and conditions from Google and its licensors
              <a
                href="https://policies.google.com/terms?hl=en&amp;gl=US"
                class="anchor-tag-color"
                title="https://policies.google.com/terms?hl=en&amp;gl=US"
                >(https://policies.google.com/terms?hl=en&gl=US </a
              >- Google Terms). By using the Application, you agree to be bound by these Terms,
              located at
              <a
                href="http://www.whiteplainshonda.com/"
                class="anchor-tag-color"
                title="http://www.whiteplainshonda.com/"
                >www.WhitePlainsHonda.com</a
              >
              and the Google Terms.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">USEAGE</div>
            <div class="mt-1">
              The Application will allow you to use your Google Assistant-enabled device (Assistant
              Device) to communicate with us for certain purposes, which may include: (a) scheduling
              a loaner car, (b) setting a service appointment; (c) booking a test drive; or (d)
              obtaining directions and store hours. From time to time, we may add or delete the
              features or functionality available through the Application. By enabling the
              Application, you are authorizing us to share the information requested from us and
              provided by you with Google and/or to perform the actions communicated to us.
            </div>
            <div class="mt-4">
              Your communications with us through the Application will be converted by Google into
              an Assistant Service Interaction ("Interaction") which will then be retained and used
              by Google and subject to the Google Terms. The Application is provided to you free of
              charge, however, you may incur data charges under your mobile or internet service
              plan.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">PRIVACY</div>
            <div class="mt-1">
              Respecting your privacy and protecting your personal information is important to us.
              The types of information we collect and how we use them are set forth in our
              <span class="font-weight-bold">Privacy Policy</span>, located at
              <a
                href="http://www.whiteplainshonda.com/"
                class="anchor-tag-color"
                title="http://www.whiteplainshonda.com/"
                >www.WhitePlainsHonda.com</a
              >
              and is incorporated into these Terms by reference. By using the Application, you
              consent to the collection and use of personal information in accordance with our
              Privacy Policy.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">LIMITED LICENSE</div>
            <div class="mt-1">
              Subject to your complying with these Terms, you are granted a limited, revocable,
              nontransferable license to access and use the Application to which you have properly
              gained access, and solely for your information and personal, non‐commercial use. Any
              use of the Application other than as specifically authorized by these Terms is
              strictly prohibited and will automatically and immediately terminate the rights and
              licenses granted herein. You may also be subjected to liability for damages and other
              claims. Such unauthorized use may also violate applicable laws.
            </div>
            <div class="mt-4">
              Unless explicitly stated herein, nothing in these Terms shall be construed as
              conferring any license to intellectual property (IP) rights, whether by estoppel,
              implication or otherwise. Except for content you provide, all content onthe
              Application is owned by or licensed to us, with all rights reserved, and is subject to
              and protected by copyright and other IP rights and laws.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">USER CONDUCT</div>
            <div class="mt-1">
              In using the Application, you may not, and it may be unlawful if you: (a) impersonate
              any person or entity, create a false identity, falsely state or otherwise misrepresent
              yourself, your age or your affiliation with any person or entity, or attempt to use
              another person's account; (b) copy, transmit, display, distribute, download, modify,
              publish, post, reproduce, or otherwise use the Application for commercial or public
              purposes without our prior written consent; (c) use data mining, automated scripts,
              robots or similar data gathering or extraction tools or processes; (d) use the
              Application in any unlawful manner or in any other manner that could damage, disable,
              overburden or impair the Application; or (e) upload, post, transmit, share, store or
              otherwise make available any material that (i) contains software viruses or any other
              computer code, files or programs designed to interrupt, destroy or limit the
              functionality of any computer software, hardware or equipment or that would
              constitute, encourage or provide instructions for a criminal offense, violate the
              rights of any party, or otherwise create liability or violate any law; or (ii) may, in
              our sole judgment, be harmful, threatening, unlawful, defamatory, infringing, abusive,
              inflammatory, vulgar, obscene, racist, fraudulent, invasive of privacy or publicity
              rights, hateful, or racially, ethnically or otherwise objectionable, or otherwise
              contrary to law or regulation.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">DISCLAIMERS</div>
            <div class="mt-1">
              The Application is provided "AS IS" and “WHERE IS”, without warranties of any kind,
              express or implied, including, without limitation, implied warranties of
              merchantability, fitness for a particular purpose, or non‐infringement. We do not
              warrant that the Application will be uninterrupted or error free, that any specific
              information requested will be provided or that the Application will be free of
              computer viruses or other harmful elements. We are not responsible for any errors or
              omissions in your use of or communication with us via the Application. You expressly
              agree that the entire risk as to the quality and performance of this Application and
              the accuracy, timeliness or completeness of the information provided through it, is
              assumed solely by you. Some states do not allow limitations on implied warranties, so
              the above limitations, in full or in part, may not apply to you.
            </div>
            <div class="mt-4">
              Your use of or access to the Application may be denied at any time, without or without
              notice, and for any or no reason. The Application may be modified or discontinued at
              any time, without or without notice, and for any or no reason. You agree that we will
              not be liable to you or any third party for any denial of access to, or modification
              or discontinuation of the Application or any claims of loss, damages or other
              resulting events.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">JURISDICTIONS</div>
            <div class="mt-1">
              The Application is controlled and operated from within the United States. We make no
              representation that the Application, including the information we collect, complies
              with the laws of any foreign jurisdictions. If you choose to access the Application
              from outside the United States, you do so at your own risk and are responsible for
              compliance with any applicable foreign laws.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">TRADEMARKS</div>
            <div class="mt-1">
              All of the trademarks, trade names, service marks, logos, graphics, designs, brands,
              and service names (Marks) appearing on the Application are either our registered
              trademarks, trademarks or trade dress, or are licensed to us for our use. None of the
              Marks may be used, including as part of trademarks and/or as part of domain names, in
              connection with any product or service in any manner that is likely to cause
              confusion, and may not be copied, imitated, or used, in whole or in part, without our
              prior written permission. Nothing on the Application should be construed as granting,
              to any person or entity, by implication or otherwise, any license or right to use any
              of the Marks.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">COMPLIANCE WITH LAW ENFORCEMENT</div>
            <div class="mt-1">
              We will cooperate with government and law enforcement officials, courts, as well as
              private parties, to enforce and comply with the law. We may disclose any information
              about you to government or law enforcement officials or private parties that, in our
              sole discretion, we believe necessary or appropriate to respond to claims and legal
              process including, but not limited to, subpoenas, to protect our property and rights
              or that of a third party, to protect the safety of the public or any person, or to
              prevent or stop activity we may consider to be, or to pose a risk of being, illegal,
              unethical or subject to legal action.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CHILDREN</div>
            <div class="mt-1">
              Any use of or access to the Application by anyone under 13 or such other older age if
              required by law (the “required age”) is not permitted and violates these Terms. By
              using or accessing the Application, you represent and warrant that you are the
              required age or older and fully able to agree to and abide by all of our Terms. We may
              suspend or terminate your user account and delete any profiles, content, or data you
              may have created or posted if we believe, in our sole discretion, that you are less
              than the required age.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">INDEMNIFICATION</div>
            <div class="mt-1">
              You agree to indemnify and hold us, our affiliates, and our agents, contractors and
              vendors, and each of our and their owners, directors, officers, employees, and agents
              (the Indemnified Parties) harmless from and against any and all losses, liabilities,
              claims, demands, damages, costs and expenses, including reasonable attorney's fees,
              arising out of or in connection with your use of the Applications or Services, or any
              violation of these Terms or of any law or the rights of any user or other third party.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">LIMITATION OF LIABILITY</div>
            <div class="mt-1">
              In no event will any of the Indemnified Parties be liable to you or any third party
              for any indirect, consequential, exemplary, incidental, special or punitive damages,
              including for any lost profits or lost data arising from your use of the Application,
              or any of the content accessed through the Application, even if they are aware or have
              been advised of the possibility of such damages. In no case shall the Indemnified
              Parties’ cumulative liability to you for any cause whatsoever, and regardless of the
              form of the action. Because certain state laws do not allow the exclusion or
              limitation of certain damages, these limitations, in full or in part, may not apply to
              you.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">DISPUTE RESOLUTION/GOVERNING LAW</div>
            <div class="mt-1">
              With respect to any dispute, you agree to first contact us and work with us in good
              faith to attempt to resolve the dispute. In the event we are not able to resolve the
              dispute, we each agree to resolve any claim, dispute, or controversy arising out of or
              in connection with or relating to these Terms, or the breach or alleged breach thereof
              (collectively, Claims), through binding arbitration by JAMS under the Comprehensive
              Arbitration Rules and Procedures then in effect for JAMS. The arbitration shall take
              place in the state and county where our corporate headquarters is located. By using
              the Application, you agree that the laws of that state, without regard to its choice
              of law principles, will govern these Terms and any dispute of any sort that might
              arise between us. The application of the United Nations Convention on Contracts for
              the International Sale of Goods is expressly excluded. Notwithstanding the foregoing,
              either party may seek injunctive or other equitable relief from any court of competent
              jurisdiction for matters related to data security, IP, or unauthorized access to the
              Application. You agree to waive any and all rights you may have to trial by jury,
              class-action claims and proceedings.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CORPORATE TRANSFER</div>
            <div class="mt-1">
              In the course of a corporate merger, acquisition, divestiture, asset sale, joint
              venture, bankruptcy, dissolution, reorganization, or any other similar transaction or
              proceeding, we may sell, divest, transfer, assign, share or otherwise engage in a
              transaction that involves some or all of our assets, including your user account
              information and content.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">GENERAL</div>
            <div class="mt-1">
              We may modify these Terms, at any time and for any reason, by posting the revised
              Terms on our website. Your use of the Application after any such posting indicates
              your acceptance of the modified Terms. In the event any portion of these Terms is held
              to be invalid or unenforceable, then such portion shall be construed in accordance
              with the applicable law as nearly as possible to reflect our original intentions; the
              remainder of these Terms shall remain in full force and effect. All provisions of
              these Terms that, by their terms, are reasonably expected to survive their termination
              shall survive such termination. These Terms contain the entire agreement concerning
              your use of the Application and supersede all existing agreements and all other oral,
              written or other communication between us concerning its subject matter. No waiver of
              these Terms shall be effective unless in writing. Except as otherwise expressly stated
              in these Terms, there shall be no third‐party beneficiaries.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CONTACT US</div>
            <div class="mt-1">
              For any questions or concerns regarding these Terms, please email us at
              <a
                class="anchor-tag-color"
                href="mailto:info@whiteplainshonda.com"
                title="mailto:info@whiteplainshonda.com"
                >info@whiteplainshonda.com.</a
              >
              We will make every effort to respond promptly and address your concerns.
            </div>
          </div>
        </div>

        <div
          class="paragon-acura grey-color-text"
          v-if="vehicleAccounts.PARAGONACURA === currentAccountId"
        >
          <div class="blue-text font-weight-bold">PARAGON ACURA - GOOGLE ASSISTANT</div>
          <div class="blue-text font-weight-bold mt-2">TERMS OF USE</div>
          <div class="red-text mt-2"><em>Updated: June 26, 2019</em></div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">ACCEPTANCE OF TERMS</div>
            <div class="mt-1">
              These <span class="font-weight-bold">Google Assistant Terms of Use</span> (or Terms)
              govern your use of our Google Assistant Action (Application). Before using the
              Application, you should review any terms and conditions from Google and its licensors
              <a
                href="https://policies.google.com/terms?hl=en&amp;gl=US"
                class="anchor-tag-color"
                title="https://policies.google.com/terms?hl=en&amp;gl=US"
                >(https://policies.google.com/terms?hl=en&gl=US </a
              >- Google Terms). By using the Application, you agree to be bound by these Terms,
              located at
              <a
                href="http://www.ParagonAcura.com/"
                class="anchor-tag-color"
                title="http://www.ParagonAcura.com/"
                >www.ParagonAcura.com</a
              >
              and the Google Terms.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">USEAGE</div>
            <div class="mt-1">
              The Application will allow you to use your Google Assistant-enabled device (Assistant
              Device) to communicate with us for certain purposes, which may include: (a) scheduling
              a loaner car, (b) setting a service appointment; (c) booking a test drive; or (d)
              obtaining directions and store hours. From time to time, we may add or delete the
              features or functionality available through the Application. By enabling the
              Application, you are authorizing us to share the information requested from us and
              provided by you with Google and/or to perform the actions communicated to us.
            </div>
            <div class="mt-4">
              Your communications with us through the Application will be converted by Google into
              an Assistant Service Interaction ("Interaction") which will then be retained and used
              by Google and subject to the Google Terms. The Application is provided to you free of
              charge, however, you may incur data charges under your mobile or internet service
              plan.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">PRIVACY</div>
            <div class="mt-1">
              Respecting your privacy and protecting your personal information is important to us.
              The types of information we collect and how we use them are set forth in our
              <span class="font-weight-bold">Privacy Policy</span>, located at
              <a
                href="http://www.ParagonAcura.com/"
                title="http://www.ParagonAcura.com/"
                class="anchor-tag-color"
                >www.ParagonAcura.com</a
              >
              and is incorporated into these Terms by reference. By using the Application, you
              consent to the collection and use of personal information in accordance with our
              Privacy Policy.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">LIMITED LICENSE</div>
            <div class="mt-1">
              Subject to your complying with these Terms, you are granted a limited, revocable,
              nontransferable license to access and use the Application to which you have properly
              gained access, and solely for your information and personal, non‐commercial use. Any
              use of the Application other than as specifically authorized by these Terms is
              strictly prohibited and will automatically and immediately terminate the rights and
              licenses granted herein. You may also be subjected to liability for damages and other
              claims. Such unauthorized use may also violate applicable laws.
            </div>
            <div class="mt-4">
              Unless explicitly stated herein, nothing in these Terms shall be construed as
              conferring any license to intellectual property (IP) rights, whether by estoppel,
              implication or otherwise. Except for content you provide, all content onthe
              Application is owned by or licensed to us, with all rights reserved, and is subject to
              and protected by copyright and other IP rights and laws.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">USER CONDUCT</div>
            <div class="mt-1">
              In using the Application, you may not, and it may be unlawful if you: (a) impersonate
              any person or entity, create a false identity, falsely state or otherwise misrepresent
              yourself, your age or your affiliation with any person or entity, or attempt to use
              another person's account; (b) copy, transmit, display, distribute, download, modify,
              publish, post, reproduce, or otherwise use the Application for commercial or public
              purposes without our prior written consent; (c) use data mining, automated scripts,
              robots or similar data gathering or extraction tools or processes; (d) use the
              Application in any unlawful manner or in any other manner that could damage, disable,
              overburden or impair the Application; or (e) upload, post, transmit, share, store or
              otherwise make available any material that (i) contains software viruses or any other
              computer code, files or programs designed to interrupt, destroy or limit the
              functionality of any computer software, hardware or equipment or that would
              constitute, encourage or provide instructions for a criminal offense, violate the
              rights of any party, or otherwise create liability or violate any law; or (ii) may, in
              our sole judgment, be harmful, threatening, unlawful, defamatory, infringing, abusive,
              inflammatory, vulgar, obscene, racist, fraudulent, invasive of privacy or publicity
              rights, hateful, or racially, ethnically or otherwise objectionable, or otherwise
              contrary to law or regulation.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">DISCLAIMERS</div>
            <div class="mt-1">
              The Application is provided "AS IS" and “WHERE IS”, without warranties of any kind,
              express or implied, including, without limitation, implied warranties of
              merchantability, fitness for a particular purpose, or non‐infringement. We do not
              warrant that the Application will be uninterrupted or error free, that any specific
              information requested will be provided or that the Application will be free of
              computer viruses or other harmful elements. We are not responsible for any errors or
              omissions in your use of or communication with us via the Application. You expressly
              agree that the entire risk as to the quality and performance of this Application and
              the accuracy, timeliness or completeness of the information provided through it, is
              assumed solely by you. Some states do not allow limitations on implied warranties, so
              the above limitations, in full or in part, may not apply to you.
            </div>
            <div class="mt-4">
              Your use of or access to the Application may be denied at any time, without or without
              notice, and for any or no reason. The Application may be modified or discontinued at
              any time, without or without notice, and for any or no reason. You agree that we will
              not be liable to you or any third party for any denial of access to, or modification
              or discontinuation of the Application or any claims of loss, damages or other
              resulting events.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">JURISDICTIONS</div>
            <div class="mt-1">
              The Application is controlled and operated from within the United States. We make no
              representation that the Application, including the information we collect, complies
              with the laws of any foreign jurisdictions. If you choose to access the Application
              from outside the United States, you do so at your own risk and are responsible for
              compliance with any applicable foreign laws.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">TRADEMARKS</div>
            <div class="mt-1">
              All of the trademarks, trade names, service marks, logos, graphics, designs, brands,
              and service names (Marks) appearing on the Application are either our registered
              trademarks, trademarks or trade dress, or are licensed to us for our use. None of the
              Marks may be used, including as part of trademarks and/or as part of domain names, in
              connection with any product or service in any manner that is likely to cause
              confusion, and may not be copied, imitated, or used, in whole or in part, without our
              prior written permission. Nothing on the Application should be construed as granting,
              to any person or entity, by implication or otherwise, any license or right to use any
              of the Marks.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">COMPLIANCE WITH LAW ENFORCEMENT</div>
            <div class="mt-1">
              We will cooperate with government and law enforcement officials, courts, as well as
              private parties, to enforce and comply with the law. We may disclose any information
              about you to government or law enforcement officials or private parties that, in our
              sole discretion, we believe necessary or appropriate to respond to claims and legal
              process including, but not limited to, subpoenas, to protect our property and rights
              or that of a third party, to protect the safety of the public or any person, or to
              prevent or stop activity we may consider to be, or to pose a risk of being, illegal,
              unethical or subject to legal action.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CHILDREN</div>
            <div class="mt-1">
              Any use of or access to the Application by anyone under 13 or such other older age if
              required by law (the “required age”) is not permitted and violates these Terms. By
              using or accessing the Application, you represent and warrant that you are the
              required age or older and fully able to agree to and abide by all of our Terms. We may
              suspend or terminate your user account and delete any profiles, content, or data you
              may have created or posted if we believe, in our sole discretion, that you are less
              than the required age.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">INDEMNIFICATION</div>
            <div class="mt-1">
              You agree to indemnify and hold us, our affiliates, and our agents, contractors and
              vendors, and each of our and their owners, directors, officers, employees, and agents
              (the Indemnified Parties) harmless from and against any and all losses, liabilities,
              claims, demands, damages, costs and expenses, including reasonable attorney's fees,
              arising out of or in connection with your use of the Applications or Services, or any
              violation of these Terms or of any law or the rights of any user or other third party.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">LIMITATION OF LIABILITY</div>
            <div class="mt-1">
              In no event will any of the Indemnified Parties be liable to you or any third party
              for any indirect, consequential, exemplary, incidental, special or punitive damages,
              including for any lost profits or lost data arising from your use of the Application,
              or any of the content accessed through the Application, even if they are aware or have
              been advised of the possibility of such damages. In no case shall the Indemnified
              Parties’ cumulative liability to you for any cause whatsoever, and regardless of the
              form of the action. Because certain state laws do not allow the exclusion or
              limitation of certain damages, these limitations, in full or in part, may not apply to
              you.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">DISPUTE RESOLUTION/GOVERNING LAW</div>
            <div class="mt-1">
              With respect to any dispute, you agree to first contact us and work with us in good
              faith to attempt to resolve the dispute. In the event we are not able to resolve the
              dispute, we each agree to resolve any claim, dispute, or controversy arising out of or
              in connection with or relating to these Terms, or the breach or alleged breach thereof
              (collectively, Claims), through binding arbitration by JAMS under the Comprehensive
              Arbitration Rules and Procedures then in effect for JAMS. The arbitration shall take
              place in the state and county where our corporate headquarters is located. By using
              the Application, you agree that the laws of that state, without regard to its choice
              of law principles, will govern these Terms and any dispute of any sort that might
              arise between us. The application of the United Nations Convention on Contracts for
              the International Sale of Goods is expressly excluded. Notwithstanding the foregoing,
              either party may seek injunctive or other equitable relief from any court of competent
              jurisdiction for matters related to data security, IP, or unauthorized access to the
              Application. You agree to waive any and all rights you may have to trial by jury,
              class-action claims and proceedings.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CORPORATE TRANSFER</div>
            <div class="mt-1">
              In the course of a corporate merger, acquisition, divestiture, asset sale, joint
              venture, bankruptcy, dissolution, reorganization, or any other similar transaction or
              proceeding, we may sell, divest, transfer, assign, share or otherwise engage in a
              transaction that involves some or all of our assets, including your user account
              information and content.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">GENERAL</div>
            <div class="mt-1">
              We may modify these Terms, at any time and for any reason, by posting the revised
              Terms on our website. Your use of the Application after any such posting indicates
              your acceptance of the modified Terms. In the event any portion of these Terms is held
              to be invalid or unenforceable, then such portion shall be construed in accordance
              with the applicable law as nearly as possible to reflect our original intentions; the
              remainder of these Terms shall remain in full force and effect. All provisions of
              these Terms that, by their terms, are reasonably expected to survive their termination
              shall survive such termination. These Terms contain the entire agreement concerning
              your use of the Application and supersede all existing agreements and all other oral,
              written or other communication between us concerning its subject matter. No waiver of
              these Terms shall be effective unless in writing. Except as otherwise expressly stated
              in these Terms, there shall be no third‐party beneficiaries.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CONTACT US</div>
            <div class="mt-1">
              For any questions or concerns regarding these Terms, please email us at
              <a
                class="anchor-tag-color"
                title="mailto:info@paragonacura.com"
                href="mailto:info@paragonacura.com"
                >info@paragonacura.com.</a
              >
              We will make every effort to respond promptly and address your concerns.
            </div>
          </div>
        </div>

        <div
          class="paragon-honda grey-color-text"
          v-if="vehicleAccounts.PARAGONHONDA === currentAccountId"
        >
          <div class="blue-text font-weight-bold">PARAGON HONDA - GOOGLE ASSISTANT</div>
          <div class="blue-text font-weight-bold mt-2">TERMS OF USE</div>
          <div class="red-text mt-2"><em>Updated: June 26, 2019</em></div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">ACCEPTANCE OF TERMS</div>
            <div class="mt-1">
              These <span class="font-weight-bold">Google Assistant Terms of Use</span> (or Terms)
              govern your use of our Google Assistant Action (Application). Before using the
              Application, you should review any terms and conditions from Google and its licensors
              <a
                href="https://policies.google.com/terms?hl=en&amp;gl=US"
                class="anchor-tag-color"
                title="https://policies.google.com/terms?hl=en&amp;gl=US"
                >(https://policies.google.com/terms?hl=en&gl=US </a
              >- Google Terms). By using the Application, you agree to be bound by these Terms,
              located at
              <a
                href="http://www.paragonhonda.com/"
                class="anchor-tag-color"
                title="http://www.paragonhonda.com/"
              >
                www.ParagonHonda.com
              </a>
              and the Google Terms.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">USEAGE</div>
            <div>
              The Application will allow you to use your Google Assistant-enabled device (Assistant
              Device) to communicate with us for certain purposes, which may include: (a) scheduling
              a loaner car, (b) setting a service appointment; (c) booking a test drive; or (d)
              obtaining directions and store hours. From time to time, we may add or delete the
              features or functionality available through the Application. By enabling the
              Application, you are authorizing us to share the information requested from us and
              provided by you with Google and/or to perform the actions communicated to us.
            </div>
            <div class="mt-4">
              Your communications with us through the Application will be converted by Google into
              an Assistant Service Interaction ("Interaction") which will then be retained and used
              by Google and subject to the Google Terms. The Application is provided to you free of
              charge, however, you may incur data charges under your mobile or internet service
              plan.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">PRIVACY</div>
            <div class="mt-1">
              Respecting your privacy and protecting your personal information is important to us.
              The types of information we collect and how we use them are set forth in our
              <span class="font-weight-bold">Privacy Policy</span>, located at
              <a
                href="http://www.paragonhonda.com/"
                title="http://www.paragonhonda.com/"
                class="anchor-tag-color"
              >
                www.ParagonHonda.com
              </a>
              and is incorporated into these Terms by reference. By using the Application, you
              consent to the collection and use of personal information in accordance with our
              Privacy Policy.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">LIMITED LICENSE</div>
            <div class="mt-1">
              Subject to your complying with these Terms, you are granted a limited, revocable,
              nontransferable license to access and use the Application to which you have properly
              gained access, and solely for your information and personal, non‐commercial use. Any
              use of the Application other than as specifically authorized by these Terms is
              strictly prohibited and will automatically and immediately terminate the rights and
              licenses granted herein. You may also be subjected to liability for damages and other
              claims. Such unauthorized use may also violate applicable laws.
            </div>
            <div class="mt-4">
              Unless explicitly stated herein, nothing in these Terms shall be construed as
              conferring any license to intellectual property (IP) rights, whether by estoppel,
              implication or otherwise. Except for content you provide, all content onthe
              Application is owned by or licensed to us, with all rights reserved, and is subject to
              and protected by copyright and other IP rights and laws.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">USER CONDUCT</div>
            <div class="mt-1">
              In using the Application, you may not, and it may be unlawful if you: (a) impersonate
              any person or entity, create a false identity, falsely state or otherwise misrepresent
              yourself, your age or your affiliation with any person or entity, or attempt to use
              another person's account; (b) copy, transmit, display, distribute, download, modify,
              publish, post, reproduce, or otherwise use the Application for commercial or public
              purposes without our prior written consent; (c) use data mining, automated scripts,
              robots or similar data gathering or extraction tools or processes; (d) use the
              Application in any unlawful manner or in any other manner that could damage, disable,
              overburden or impair the Application; or (e) upload, post, transmit, share, store or
              otherwise make available any material that (i) contains software viruses or any other
              computer code, files or programs designed to interrupt, destroy or limit the
              functionality of any computer software, hardware or equipment or that would
              constitute, encourage or provide instructions for a criminal offense, violate the
              rights of any party, or otherwise create liability or violate any law; or (ii) may, in
              our sole judgment, be harmful, threatening, unlawful, defamatory, infringing, abusive,
              inflammatory, vulgar, obscene, racist, fraudulent, invasive of privacy or publicity
              rights, hateful, or racially, ethnically or otherwise objectionable, or otherwise
              contrary to law or regulation.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">DISCLAIMERS</div>
            <div class="mt-1">
              The Application is provided "AS IS" and “WHERE IS”, without warranties of any kind,
              express or implied, including, without limitation, implied warranties of
              merchantability, fitness for a particular purpose, or non‐infringement. We do not
              warrant that the Application will be uninterrupted or error free, that any specific
              information requested will be provided or that the Application will be free of
              computer viruses or other harmful elements. We are not responsible for any errors or
              omissions in your use of or communication with us via the Application. You expressly
              agree that the entire risk as to the quality and performance of this Application and
              the accuracy, timeliness or completeness of the information provided through it, is
              assumed solely by you. Some states do not allow limitations on implied warranties, so
              the above limitations, in full or in part, may not apply to you.
            </div>
            <div class="mt-4">
              Your use of or access to the Application may be denied at any time, without or without
              notice, and for any or no reason. The Application may be modified or discontinued at
              any time, without or without notice, and for any or no reason. You agree that we will
              not be liable to you or any third party for any denial of access to, or modification
              or discontinuation of the Application or any claims of loss, damages or other
              resulting events.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">JURISDICTIONS</div>
            <div class="mt-1">
              The Application is controlled and operated from within the United States. We make no
              representation that the Application, including the information we collect, complies
              with the laws of any foreign jurisdictions. If you choose to access the Application
              from outside the United States, you do so at your own risk and are responsible for
              compliance with any applicable foreign laws.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">TRADEMARKS</div>
            <div class="mt-1">
              All of the trademarks, trade names, service marks, logos, graphics, designs, brands,
              and service names (Marks) appearing on the Application are either our registered
              trademarks, trademarks or trade dress, or are licensed to us for our use. None of the
              Marks may be used, including as part of trademarks and/or as part of domain names, in
              connection with any product or service in any manner that is likely to cause
              confusion, and may not be copied, imitated, or used, in whole or in part, without our
              prior written permission. Nothing on the Application should be construed as granting,
              to any person or entity, by implication or otherwise, any license or right to use any
              of the Marks.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">COMPLIANCE WITH LAW ENFORCEMENT</div>
            <div class="mt-1">
              We will cooperate with government and law enforcement officials, courts, as well as
              private parties, to enforce and comply with the law. We may disclose any information
              about you to government or law enforcement officials or private parties that, in our
              sole discretion, we believe necessary or appropriate to respond to claims and legal
              process including, but not limited to, subpoenas, to protect our property and rights
              or that of a third party, to protect the safety of the public or any person, or to
              prevent or stop activity we may consider to be, or to pose a risk of being, illegal,
              unethical or subject to legal action.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CHILDREN</div>
            <div class="mt-1">
              Any use of or access to the Application by anyone under 13 or such other older age if
              required by law (the “required age”) is not permitted and violates these Terms. By
              using or accessing the Application, you represent and warrant that you are the
              required age or older and fully able to agree to and abide by all of our Terms. We may
              suspend or terminate your user account and delete any profiles, content, or data you
              may have created or posted if we believe, in our sole discretion, that you are less
              than the required age.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">INDEMNIFICATION</div>
            <div class="mt-1">
              You agree to indemnify and hold us, our affiliates, and our agents, contractors and
              vendors, and each of our and their owners, directors, officers, employees, and agents
              (the Indemnified Parties) harmless from and against any and all losses, liabilities,
              claims, demands, damages, costs and expenses, including reasonable attorney's fees,
              arising out of or in connection with your use of the Applications or Services, or any
              violation of these Terms or of any law or the rights of any user or other third party.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">LIMITATION OF LIABILITY</div>
            <div>
              In no event will any of the Indemnified Parties be liable to you or any third party
              for any indirect, consequential, exemplary, incidental, special or punitive damages,
              including for any lost profits or lost data arising from your use of the Application,
              or any of the content accessed through the Application, even if they are aware or have
              been advised of the possibility of such damages. In no case shall the Indemnified
              Parties’ cumulative liability to you for any cause whatsoever, and regardless of the
              form of the action. Because certain state laws do not allow the exclusion or
              limitation of certain damages, these limitations, in full or in part, may not apply to
              you.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">DISPUTE RESOLUTION/GOVERNING LAW</div>
            <div class="mt-1">
              With respect to any dispute, you agree to first contact us and work with us in good
              faith to attempt to resolve the dispute. In the event we are not able to resolve the
              dispute, we each agree to resolve any claim, dispute, or controversy arising out of or
              in connection with or relating to these Terms, or the breach or alleged breach thereof
              (collectively, Claims), through binding arbitration by JAMS under the Comprehensive
              Arbitration Rules and Procedures then in effect for JAMS. The arbitration shall take
              place in the state and county where our corporate headquarters is located. By using
              the Application, you agree that the laws of that state, without regard to its choice
              of law principles, will govern these Terms and any dispute of any sort that might
              arise between us. The application of the United Nations Convention on Contracts for
              the International Sale of Goods is expressly excluded. Notwithstanding the foregoing,
              either party may seek injunctive or other equitable relief from any court of competent
              jurisdiction for matters related to data security, IP, or unauthorized access to the
              Application. You agree to waive any and all rights you may have to trial by jury,
              class-action claims and proceedings.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CORPORATE TRANSFER</div>
            <div class="mt-1">
              In the course of a corporate merger, acquisition, divestiture, asset sale, joint
              venture, bankruptcy, dissolution, reorganization, or any other similar transaction or
              proceeding, we may sell, divest, transfer, assign, share or otherwise engage in a
              transaction that involves some or all of our assets, including your user account
              information and content.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">GENERAL</div>
            <div class="mt-1">
              We may modify these Terms, at any time and for any reason, by posting the revised
              Terms on our website. Your use of the Application after any such posting indicates
              your acceptance of the modified Terms. In the event any portion of these Terms is held
              to be invalid or unenforceable, then such portion shall be construed in accordance
              with the applicable law as nearly as possible to reflect our original intentions; the
              remainder of these Terms shall remain in full force and effect. All provisions of
              these Terms that, by their terms, are reasonably expected to survive their termination
              shall survive such termination. These Terms contain the entire agreement concerning
              your use of the Application and supersede all existing agreements and all other oral,
              written or other communication between us concerning its subject matter. No waiver of
              these Terms shall be effective unless in writing. Except as otherwise expressly stated
              in these Terms, there shall be no third‐party beneficiaries.
            </div>
          </div>
          <div class="mt-4">
            <div class="red-text font-weight-bold">CONTACT US</div>
            <div class="mt-1">
              For any questions or concerns regarding these Terms, please email us at
              <a
                class="anchor-tag-color"
                title="mailto:info@paragonhonda.com"
                href="mailto:info@paragonhonda.com"
                >info@paragonhonda.com.
              </a>
              We will make every effort to respond promptly and address your concerns.
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import Modal from "../Shared/Modal/Modal.vue";
import * as VehicleAccountConstants from "@/js/constants/VehicleAccounts";
import { mapWritableState } from "pinia";
import { useLeadFormsStore } from "../../store/LeadForms/LeadFormsStore";
export default {
  data() {
    return {
      vehicleAccounts: VehicleAccountConstants,
      currentAccountId: window.accountId,
    };
  },
  computed: {
    ...mapWritableState(useLeadFormsStore, ["showGoogleAssistantModal"]),
  },
  props: {
    opengoogleassistant: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.showGoogleAssistantModal = false;
    },
  },
};
</script>
<style>
.blue-text {
  color: #2d73b5;
}
.red-text {
  color: #c00000;
}
.anchor-tag-color {
  color: #007bff !important;
}
.grey-color-text {
  color: #555;
}
@media (max-width: 700px) {
  .grey-color-text {
    font-size: 14px;
  }
}
</style>
